// 判断某个节点是不是另一个节点的子节点
export const isDescendant = (child: HTMLElement, parent: HTMLElement) => {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export const getDistanceFromTop = (element: HTMLElement): number => {
  let distance = 0;
  let elem: HTMLElement | null = element;

  // 循环遍历DOM，获取每个父元素的offsetTop并累加
  while (elem) {
    distance += elem.offsetTop;
    // 明确elem为HTMLElement类型，因为offsetParent的返回值是HTMLElement | null
    elem = elem.offsetParent as HTMLElement | null;
  }

  // 处理可能出现的负值情况
  distance = Math.max(0, distance);

  return distance;
};
